import { createRootRoute, Outlet } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@/components/theme-provider';
import { ErrorBoundary } from '@/components/error-boundary';
import { Toaster } from '@/components/ui/sonner';
import { queryClient } from '@/lib/query-client';
import { TOAST_OFFSET } from '@/lib/toast-offset';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent(): React.ReactElement {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ErrorBoundary>
          <Outlet />
          <Toaster
            richColors
            position="bottom-right"
            offset={TOAST_OFFSET}
            mobileOffset={TOAST_OFFSET}
          />
        </ErrorBoundary>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
